import { PrismicRichText } from "@prismicio/react";
import React from 'react';
import { useRef, useEffect } from "react";
import { components } from "../../utils/rt-mods";

export const ResultsPage = (props) => {

    const sc = props.slice.primary;

    const items = props.slice.items;

    let space = sc.spacing;

    if (space === "Both large") {
        space = "gutter";
    } else if (space === "Both small") {
        space = "gutter sm";
    } else if (space === "Top large") {
        space = "gutter bot";
    } else if (space === "Top small") {
        space = "gutter bot sm";
    } else if (space === "Bottom large") {
        space = "gutter top";
    } else {
        space = "gutter top sm";
    }


    let bg = sc.background === "gradient" ? "gradient-to-b from-grey-light to-white" : sc.background === "grey" ? "grey-light" : sc.background;

    const myRef = useRef();

    useEffect(() => {
        const observer = new IntersectionObserver(function(entries) {
            const entry = entries[0];
            if(!entry.isIntersecting){
                return;
            }
            entry.target.classList.add('start')

        })
        observer.observe(myRef.current)
    }, [])


    return (
        <section className={"results bg-" + (bg) + " " + (sc.theme) + " " + (space)}>
            <div className="wrapper">
                <div className="relative flex flex-col items-center">
                    <div className="text-center w-full md:w-3/5">
                        <PrismicRichText field={sc.section_title.richText} />
                        <PrismicRichText field={sc.section_content.richText} components={components} />
                    </div>
                <div ref={myRef} className="dta-w justify-center flex-wrap">
                        {items.map((item, index) => {
                            return (
                                <div key={index} className="dta-r">
                                    <span className={"dta text-" + item.theme}>{item.data_point.text}</span>
                                    <span>{item.data_content.text}</span>
                                </div>
                            )
                        })}
                </div>
                </div>
                
            </div>
        </section>
    );
}

